import { Flatfile } from '@flatfile/api-internal'
import { AppType } from '@flatfile/api-internal/api'

const wayfinderApps = new URL('/images/custom.jpg', import.meta.url).href
const wayfinderPortal = new URL('/images/portal.jpg', import.meta.url).href
const wayfinderProjects = new URL('/images/projects.jpg', import.meta.url).href
const wayfinderAuto = new URL('/images/autobuild.jpg', import.meta.url).href
const wayfinderFlatfileOs = new URL('/images/custom.jpg', import.meta.url).href

export interface AppOption {
  id: string
  title: string
  description: string
  imageUrl: string
  appType: AppType
  learnMoreLink: string
  condition?: boolean // Optional based on usage in your example
}

export const appConfigs: AppOption[] = [
  {
    id: 'autobuild',
    title: 'Autobuild',
    description: "Upload your template, modify your schema with AI. It's that easy.",
    imageUrl: wayfinderAuto,
    appType: Flatfile.AppType.Custom,
    learnMoreLink: '', //'https://flatfile.com/platform/autobuild/',
  },
  {
    id: 'projects',
    title: 'Projects',
    description: 'Streamline complex data workflows across diverse stakeholders.',
    imageUrl: wayfinderProjects,
    appType: Flatfile.AppType.Projects,
    learnMoreLink: 'https://flatfile.com/platform/projects/',
  },
  {
    id: 'custom',
    title: 'Build your own app',
    description: 'Use the power of the developer platform to fit your use case.',
    imageUrl: wayfinderApps,
    appType: Flatfile.AppType.Custom,
    learnMoreLink: 'https://flatfile.com/platform/orchestration/',
  },
  {
    id: 'portal',
    title: 'Embed a data importer in your app',
    description: 'Build a deeply configurable file import experience right in your application.',
    imageUrl: wayfinderPortal,
    appType: Flatfile.AppType.Portal,
    learnMoreLink: 'https://flatfile.com/platform/portal/',
  },
  {
    id: 'flatfileOs',
    title: 'Flatfile OS',
    description: 'Given a URL, use Flatfile OS to create an app based on company research.',
    imageUrl: wayfinderFlatfileOs,
    appType: Flatfile.AppType.Custom,
    learnMoreLink: '',
  },
]
